import { Button } from "antd";
import { ShimmerButton } from "components/magicui/shimmer-button";
import { useReducedMotion } from "motion/react";
import type { ComponentPropsWithoutRef, MouseEventHandler } from "react";

interface ShimmerCtaProps extends ComponentPropsWithoutRef<"button"> {
	children?: React.ReactNode;
}

export function ShimmerCta({
	children,
	onClick,
	type,
	color,
	...props
}: ShimmerCtaProps) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion) {
		// HTML's string `color` attribute clashes with AntD Button's color union,
		// so it is not forwarded on this branch.
		return (
			<Button
				type="primary"
				htmlType={type}
				onClick={onClick as MouseEventHandler<HTMLElement>}
				{...props}
			>
				{children}
			</Button>
		);
	}

	return (
		<ShimmerButton
			className="h-10 px-5 text-sm font-semibold"
			onClick={onClick}
			type={type}
			color={color}
			{...props}
		>
			{children}
		</ShimmerButton>
	);
}
